import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { AuthenticationService, UserService } from "app/auth/service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { SkillsService } from "app/auth/service/skills.service";
import { UserFigureService } from "app/auth/service/user-figure.service";
import { CandidateService } from "app/modules/recruitment/candidates/candidate.service";
import { ICustomer } from "app/modules/customer/customer.interface";
import { CustomerService } from "app/modules/customer/customer.service";
import moment from "moment";

export interface IUserPlan {
  id: number;
  hash: string;
  complete_name: string;
  type: number;
  type_code: string;
  figure_id: number;
  update_date: string;
  figure_name: string;
  cost_total_daily: string;
  skill_names: string[];
  skills: {
    name: string;
    level: string;
    primary: number;
    skill_id: number;
  }[];
  commissions: {
    rate: string;
    end_date: string;
    order_id: number;
    type?: string;
    commission: {
      id: number;
      name: string;
      type?: string;
      detachemnt_type?: boolean;
      client: {
        id: number;
        logo: string;
        name: string;
        detachment: false;
        vat_number: string;
        business_name: string;
      };
      protocol: string;
    };
    start_date: string;
    detail_task: {
      months: number;
      discount: string;
      line_amount: string;
      employee_hash: string;
      employee_name: string;
      monthly_import: string;
      tranche_single_import: string;
    }[];
    detail_time_material: {
      effort: number;
      discount: string;
      daily_rate: string;
      line_amount: string;
      employee_hash: string;
      employee_name: string;
    }[];
  }[];
  structures: {
    id: number;
    description: string;
    amount: string;
    estimate_amount: string;
    commissions_number: string;
    start_date: string;
    end_date: string;
  }[];
}

@Component({
  selector: "app-planning-list",
  templateUrl: "./planning-list.component.html",
  styleUrls: ["./planning-list.component.scss"],
})
export class PlanningListComponent implements OnInit {
  @ViewChild("table") table: any;
  public userList: IUserPlan[] = [];
  public contentHeader: IContentHeader;
  private childrenElementNumber: number = 1;
  public tableLimit: number = 10;
  public filter_figure: number = 0;
  public filter_customer: number = 0;
  public filter_skill: number[] = [0];
  public filter_string: string = "";
  public userFiltered: IUserPlan[] = [];
  public queryParams: Params = {};
  public pageNumber: number = 0;
  public customers: ICustomer[] = [];

  constructor(
    public _userFigureService: UserFigureService,
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    public _skillService: SkillsService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public _candidateService: CandidateService,
    public _userService: UserService,
    private _customerService: CustomerService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: "PLANNING",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.USERS",
            isLink: false,
          },
          {
            name: "PLANNING",
            isLink: false,
          },
        ],
      },
    };
    this.activatedRoute.queryParams.subscribe((params) => {
      const searchKey: string = params.search;
      const skill: string = params.skill;
      const figure: string = params.figure;
      const page: string = params.page;
      const customer: string = params.customer;

      if (!!searchKey) {
        this.filter_string = searchKey;
      }
      if (!!skill && skill != "0") {
        this.filter_skill = JSON.parse(skill);
      }
      if (!!figure && figure != "0") {
        this.filter_figure = Number(figure);
      }
      if (!!page) {
        this.pageNumber = Number(page);
      }
      if (!!customer && customer != "0") {
        this.filter_customer = Number(customer);
      }
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_planning_list")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.userList = await this._userService.getUserPlanning().then((r: IUserPlan[]) => {
      if (r) {
        r = r.map((item: IUserPlan) => {
          item.skill_names = item.skills.map((skill) => skill.name);
          return item;
        });
        return r.sort((a: any, b: any) => {
          const dateA = moment(a.date);
          const dateB = moment(b.date);
          return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
        });
      }
      return [];
    });
    if (this.userList && this.userList.length > 0) {
      this.userList.map((user: IUserPlan) => {
        if (user.commissions && user.commissions.length > 0) {
          user.commissions.map((comm) => {
            comm.rate = this.getRateEmployee(comm, user.hash);
          });
        }
      });
    }
    this.customers = await this._customerService.getCustomers();
    await this.getItems();
    this._utilService.hideLoading();

    await this._skillService.getList();
  }

  changeQueryParams() {
    const url = new URL(window.location.href);
    if (!!this.filter_string && this.filter_string.length >= 3) {
      url.searchParams.set("search", String(this.filter_string));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.filter_figure && this.filter_figure > 0) {
      url.searchParams.set("figure", String(this.filter_figure));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("figure");
      history.pushState({}, "", url);
    }

    if (!!this.filter_customer && this.filter_customer > 0) {
      url.searchParams.set("customer", String(this.filter_customer));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("customer");
      history.pushState({}, "", url);
    }

    if (!!this.filter_skill && !this.filter_skill.includes(0)) {
      url.searchParams.set("skill", JSON.stringify(this.filter_skill));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("skill");
      history.pushState({}, "", url);
    }
  }

  getItems() {
    let items: IUserPlan[] = this.userList;

    const keyword: string = this.filter_string.trim().toLowerCase();
    if (keyword.length > 1) {
      items = items.filter(
        (item: IUserPlan) =>
          JSON.stringify(item.skill_names).toLowerCase().includes(keyword) || item.complete_name?.toLowerCase().includes(keyword) || item.figure_name?.toLowerCase().includes(keyword) || item.hash === keyword,
      );
    }

    if (this.filter_figure > 0) {
      items = items.filter((item: IUserPlan) => Number(item.figure_id) === Number(this.filter_figure));
    }

    if (this.filter_customer > 0) {
      items = items.filter((item: IUserPlan) => {
        return item.commissions.find((comm) => comm.commission.client.id == this.filter_customer);
      });
    }

    if (!this.filter_skill.includes(0)) {
      items = items.filter((item: any) => {
        let foundedSkills: number = 0;
        item?.skill_ids?.map((id: number) => {
          if (this.filter_skill.includes(id)) {
            foundedSkills++;
          }
        });
        return foundedSkills === this.filter_skill.length;
      });
    }
    if (!this.filter_skill.includes(0)) {
      items = items.sort((a, b) => ("" + b.skills[0].level).localeCompare(a.skills[0].level));
    }

    for (let item of items) {
      for (let comm of item.commissions) {
        comm.type = comm.detail_time_material && Object.keys(comm.detail_time_material).length > 0 ? "time_material" : "";
        comm.type = comm.detail_task && Object.keys(comm.detail_task).length > 0 ? "task" : comm.type;
      }
    }

    this.userFiltered = items;
  }

  filterSkillsForCandidate(list: any) {
    if (list.length === 1) {
      return list;
    }
    if (this.filter_skill.includes(0)) {
      return list.filter((skill) => Boolean(skill.primary));
    }
    let filteredSkills = list.filter((skill) => !this.filter_skill.includes(skill.skill_id));
    return filteredSkills.slice(0, 4);
  }

  changeSkill() {
    if (this.filter_skill.includes(0) && this.filter_skill.length >= 2 && this.filter_skill[this.filter_skill.length - 1] === 0) {
      //Se include zero significa che è stata selezionata l'opzione tutte le skill, anche se l'ultimo elemento è zero
      this.filter_skill = [0];
    } else {
      if (this.filter_skill.length > 1) {
        this.filter_skill = this.filter_skill.filter((skill) => skill !== 0);
      } else if (this.filter_skill.length < 1) {
        this.filter_skill = [0];
      }
      this.getItems();
    }
  }

  setPage(pageInfo: { count: number; limit: number; offset: number; pageSize: number }) {
    this.pageNumber = pageInfo.offset;
    const url = new URL(window.location.href);

    if (!!this.pageNumber && this.pageNumber >= 1) {
      url.searchParams.set("page", String(this.pageNumber));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("page");
      history.pushState({}, "", url);
    }
  }

  getRateEmployee(commission, user_hash: string): string {
    if (commission.detail_task && commission.detail_task.length > 0) {
      const emp = commission.detail_task.find((task) => task.employee_hash === user_hash);
      if (emp) {
        return this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(emp.monthly_import) / 20);
      } else {
        return "-";
      }
    }
    if (commission.detail_time_material && commission.detail_time_material.length > 0) {
      const emp = commission.detail_time_material.find((time_mat) => time_mat.employee_hash === user_hash);
      if (emp) {
        return emp.daily_rate;
      } else {
        return "-";
      }
    }
  }

  toggleExpandRow(row, expanded) {
    if (!expanded) {
      this.table?.rowDetail.collapseAllRows();
    }

    if (row.commissions && row.commissions.length > 0) {
      this.childrenElementNumber = row.commissions.length;
    }
    if (row.structures && row.structures.length > 0) {
      this.childrenElementNumber += row.structures.length;
    }

    this.table?.rowDetail.toggleExpandRow(row);

    setTimeout(() => {
      const rowWidth: number | null = document.querySelector(".datatable-row-wrapper:first-child").clientWidth;
      const childDatatable: any = document.querySelector(".child-datatable");

      if (childDatatable) {
        childDatatable.style.width = `${rowWidth}px`;

        const anchor: any = document.querySelector(".datatable-row-wrapper:first-child a[title=\"Expand/Collapse Row\"]");
        if (anchor && this._utilService.isDesktop) {
          childDatatable.style.paddingLeft = `calc(3.65rem + ${anchor.clientWidth}px)`;
        }

        const rowDetail: any = document.querySelector(".datatable-row-detail");
        if (rowDetail) {
          rowDetail.style.height = 'fit-content';
        }
      }
    });
  }

  exportExcel() {
    if (!this._authenticationService.hasCapability("export_employee_planning")) {
      return false;
    }

    const listForExport = [];

    for (const user of this.userFiltered) {
      const userSkills = user.skills
        .sort((a, b) => (a.level > b.level ? -1 : 1))
        .slice(0, 4)
        .map((skill) => skill.name)
        .join(", ");

      for (const comm of user.commissions) {
        listForExport.push({
          "Nome e cognome": user.complete_name,
          "Figura": user.figure_name,
          "Skills": userSkills,
          "Tipo commessa": `${comm.commission.detachemnt_type ? "Distacco - " : ""}${comm.type === "time_material" ? "Time Material" : "Task"}`,
          "Commessa": `#${comm.commission.protocol} - ${comm.commission.name} - ${comm.commission.client.name}`,
          "Cliente": comm.commission.client.name,
          "Data inizio round": moment(comm.start_date).format("DD/MM/YYYY"),
          "Data fine round": moment(comm.end_date).format("DD/MM/YYYY"),
          "Tariffa": this._utilService.removeDotsFromNumber(comm.rate),
          "Costo giornaliero": Number(user.cost_total_daily),
        });
      }

      for (const structure of user.structures) {
        listForExport.push({
          "Nome e cognome": user.complete_name,
          "Figura": user.figure_name,
          "Skills": userSkills,
          "Tipo commessa": "Struttura",
          "Commessa": structure.description,
          "Cliente": this._utilService.themeConfiguration.company_nicename,
          "Data inizio round": moment(structure.start_date).format("DD/MM/YYYY"),
          "Data fine round": structure.end_date ? moment(structure.end_date).format("DD/MM/YYYY") : "",
          "Tariffa": Number(user.cost_total_daily),
          "Costo giornaliero": Number(user.cost_total_daily),
        });
      }

    }

    this._utilService.exportAsExcelFile(listForExport, "planning");
  }
}
